import { useEffect, useState } from 'react';
import './ui.css';

const COMMANDS = [
  'whoami',
  'cat about.txt',
  'npm run dev',
  'git log --oneline -5',
];

export default function TerminalPrompt() {
  const [text, setText] = useState('');
  const [cmdIndex, setCmdIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    const cmd = COMMANDS[cmdIndex];
    const delay = deleting ? 40 : 80;

    const timer = setTimeout(() => {
      if (!deleting) {
        if (charIndex < cmd.length) {
          setText(cmd.slice(0, charIndex + 1));
          setCharIndex((c) => c + 1);
        } else {
          setTimeout(() => setDeleting(true), 1800);
        }
      } else if (charIndex > 0) {
        setText(cmd.slice(0, charIndex - 1));
        setCharIndex((c) => c - 1);
      } else {
        setDeleting(false);
        setCmdIndex((i) => (i + 1) % COMMANDS.length);
      }
    }, delay);

    return () => clearTimeout(timer);
  }, [charIndex, cmdIndex, deleting]);

  return (
    <p className="terminal-prompt">
      <span className="user">yufy@beijing</span>
      :<span className="path">~/blog</span>$ {text}
      <span className="typing-cursor">▋</span>
    </p>
  );
}
